import orderBy from "lodash/orderBy";
import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {cabinetThumbnail} from "../../../kvComponent/core/assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import Handle from "../subparts/cabinet/handle";
import TopCabinet from "../subparts/cabinet/topCabinet";
import TallCabinet from "../subparts/cabinet/tallCabinet";
import CrownMolding from "../subparts/cabinet/crownMolding";
import BottomCabinet from "../subparts/cabinet/bottomCabinet";
import {setActiveFeaturesBeforeAllWalls} from "../../../look/lookNavigation/lookNavigationFunctions";
import {CABINET_GROUP} from "../../../kvComponent/core/constants";
import BottomHandle from "../subparts/cabinet/bottomHandle";
import TopHandle from "../subparts/cabinet/topHandle";
import DoorHandle from "../subparts/cabinet/doorHandle";
import DrawerHandle from "../subparts/cabinet/drawerHandle";
import FridgeEnclosure from "../subparts/cabinet/fridgeEnclosure";
import FridgeEnclosureHandle from "../subparts/cabinet/fridgeEnclosureHandle";

export default class Cabinet extends Part {
  static id = 'Cabinet';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Cabinet';
    this.partThumbnail = cabinetThumbnail;
    this.partThumbnailSize = "70%";
    this.translateId = "visualizer.kitchen.cabinet";

    // related items
    this.handle = null;
    this.bottomHandle = null;
    this.topHandle = null;
    this.topCabinet = null;
    this.doorHandle = null;
    this.drawerHandle = null;
    this.crownMolding = null;
    this.fridgeEnclosure = null;
    this.fridgeEnclosureHandle = null;
    this.relatedGroupNames = ["Handle", "Bottom Handle", "Top Handle", "Bottom Cabinet", "Top Cabinet", "Crown Molding",
      "Door Handle", "Drawer Handle", "Fridge Enclosure Handle", "Fridge Enclosure"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Handle":
        relatedItemName = "handle";
        RelatedItemClass = Handle;
        break;
      case "Top Handle":
        relatedItemName = "topHandle";
        RelatedItemClass = TopHandle;
        break;
      case "Bottom Handle":
        relatedItemName = "bottomHandle";
        RelatedItemClass = BottomHandle;
        break;
      case "Bottom Cabinet":
        relatedItemName = "bottomCabinet";
        RelatedItemClass = BottomCabinet;
        break;
      case "Top Cabinet":
        relatedItemName = "topCabinet";
        RelatedItemClass = TopCabinet;
        break;
      case "Tall Cabinet":
        relatedItemName = "tallCabinet";
        RelatedItemClass = TallCabinet;
        break;
      case "Crown Molding":
        relatedItemName = "crownMolding";
        RelatedItemClass = CrownMolding;
        break;
      case "Door Handle":
        relatedItemName = "doorHandle";
        RelatedItemClass = DoorHandle;
        break;
      case "Drawer Handle":
        relatedItemName = "drawerHandle";
        RelatedItemClass = DrawerHandle;
        break;
      case "Fridge Enclosure Handle":
        relatedItemName = "fridgeEnclosureHandle";
        RelatedItemClass = FridgeEnclosureHandle;
        break;
      case "Fridge Enclosure":
        relatedItemName = "fridgeEnclosure";
        RelatedItemClass = FridgeEnclosure;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  getRelatedItems() {
    return orderBy(this.relatedItems, 'layerPriority');
  }

  subParts(withHidden = true, hideWithoutFeatures = false) {
    return this.getRelatedItems()
      .filter(item => this.filterRelatedItem(item, withHidden))
      .filter(item => {
        if ((item.partId === "crown_molding" || item.partId === "top_handle") && hideWithoutFeatures && item.allFeaturesReceived) {
          return item.navigationSubItems({}, "").length
        }
        return item
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  getTopCabinetType() {
    if (this.topCabinet && this.topCabinet.activeFeature) {
      if (this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
        return this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
      } else {
        // console.log("no topCabinet metaData!", this.topCabinet.activeFeature);
        return ""
      }
    }
    return ""
  }

  // getTopCabinetLayout() {
  //
  //   if (this.topCabinet && this.topCabinet.activeFeature) {
  //     if (this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
  //       return this.topCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
  //     } else {
  //       // console.log("no topCabinet metaData!", this.topCabinet.activeFeature);
  //       return ""
  //     }
  //   }
  //   return "ALL"
  // }

  getBottomCabinetType() {
    if (this.bottomCabinet && this.bottomCabinet.activeFeature) {
      if (this.bottomCabinet.activeFeature.dbFeature.metaData["Cabinet"]) {
        return this.bottomCabinet.activeFeature.dbFeature.metaData["Cabinet"][0]
      } else {
        // console.log("no bottomCabinet metaData!", this.bottomCabinet.activeFeature);
        return ""
      }
    }
    return ""
  }

  getTopCabinetApplianceType() {
    if (this.topCabinet && this.topCabinet.activeFeature) {
      if (this.topCabinet.activeFeature.dbFeature.metaData["Appliance"]) {
        return this.topCabinet.activeFeature.dbFeature.metaData["Appliance"][0]
      } else {
        // console.log("no Appliance metaData!", this.topCabinet.activeFeature);
        return "Hood"
      }
    }
    return "Hood"
  }

  getTopCabinetShadowLayout() {
    if (this.topCabinet && this.topCabinet.activeFeature && this.topCabinet.activeFeature.dbFeature.metaData["CabinetLayout"]) {
      return this.topCabinet.activeFeature.dbFeature.metaData["CabinetLayout"][0]
    }
    return ""
  }

  getBottomCabinetApplianceType() {
    if (this.bottomCabinet && this.bottomCabinet.activeFeature) {
      if (this.bottomCabinet.activeFeature.dbFeature.metaData["Appliance"]) {
        return this.bottomCabinet.activeFeature.dbFeature.metaData["Appliance"][0]
      } else {
        // console.log("no Appliance metaData!", this.bottomCabinet.activeFeature);
        return "Range"
      }
    }
    return "Range"
  }

  setPrevioslySelected() {
    setActiveFeaturesBeforeAllWalls(CABINET_GROUP);
  }

}
